import {isCoches} from '../../config/index.js'

export const CRITEO = 'criteo'
export const GOOGLE_ADS = 'google_ads'
export const RTB_HOUSE = 'rtb_house'

const CRITEO_ACCOUNTS_COCHES = [16413, 21384, 44782, 97204]
const CRITEO_ACCOUNTS_MOTOS = [25136]

const getCriteoAccountsQueryParams = isCoches => {
  const CRITEO_ACCOUNTS = isCoches ? CRITEO_ACCOUNTS_COCHES : CRITEO_ACCOUNTS_MOTOS
  return CRITEO_ACCOUNTS.map(criteoAccount => `a=${criteoAccount}`).join('&')
}

export default {
  [CRITEO]: {
    SCRIPT_URL: `//dynamic.criteo.com/js/ld/ld.js?${getCriteoAccountsQueryParams(isCoches)}`,
    CRITEO_ATTRIBUTION_SESSION_KEY: 'isCriteo',
    CRITEO_ATTRIBUTION_REGEX:
      /.*utm_medium=retargeting(&|$).*utm_source=criteo(&|$).*utm_campaign=marketplace_display(&|$)/i
  },
  [GOOGLE_ADS]: {
    CONVERSION_ID: 'AW-1054000236',
    SCRIPT_BASE_URL: 'https://www.googletagmanager.com/gtag/js?id='
  }
}
